// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* variables used throughout our scss AND bootstrap variables */
.light-gray {
  color: #f3f3f3 !important;
}

.dark-gray {
  color: #4a4a4a !important;
}

.mid-gray {
  color: #dcdcdc !important;
}

.icon-gray {
  color: #9e9fa1 !important;
}

.red {
  color: #da291c !important;
}

.dark-red {
  color: #af2218 !important;
}

.white {
  color: #fff !important;
}

.duckegg-blue {
  color: #e4f4fd !important;
}

.powder-blue {
  color: #deecfd !important;
}

.light-blue {
  color: #35b2e2 !important;
}

.link-blue {
  color: #007bff !important;
}

.blue {
  color: #009cde !important;
}

.dark-blue {
  color: #025a95 !important;
}

.teal {
  color: #01a3b0 !important;
}

.light-yellow {
  color: #fce8b6 !important;
}

.yellow {
  color: #f0b323 !important;
}

.orange {
  color: #df6d00 !important;
}

.green {
  color: #5ba400 !important;
}

.filter-light-gray {
  filter: invert(100%) sepia(5%) saturate(88%) hue-rotate(108deg) brightness(109%) contrast(91%);
}

.filter-dark-gray {
  filter: invert(17%) sepia(57%) saturate(0%) hue-rotate(201deg) brightness(105%) contrast(70%);
}

.filter-icon-gray {
  filter: invert(78%) sepia(6%) saturate(48%) hue-rotate(182deg) brightness(82%) contrast(84%);
}

.filter-mid-gray {
  filter: invert(26%) sepia(0%) saturate(0%) hue-rotate(36deg) brightness(99%) contrast(87%);
}

.filter-red {
  filter: invert(19%) sepia(48%) saturate(6736%) hue-rotate(356deg) brightness(91%) contrast(86%);
}

.filter-dark-red {
  filter: invert(17%) sepia(80%) saturate(2657%) hue-rotate(347deg) brightness(92%) contrast(108%);
}

.filter-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

.filter-duckegg-blue {
  filter: invert(90%) sepia(7%) saturate(746%) hue-rotate(183deg) brightness(103%) contrast(104%);
}

.filter-powder-blue {
  filter: invert(80%) sepia(14%) saturate(308%) hue-rotate(180deg) brightness(112%) contrast(98%);
}

.filter-light-blue {
  filter: invert(70%) sepia(90%) saturate(1920%) hue-rotate(164deg) brightness(90%) contrast(97%);
}

.filter-link-blue {
  filter: invert(25%) sepia(91%) saturate(1698%) hue-rotate(175deg) brightness(99%) contrast(101%);
}

.filter-blue {
  filter: invert(41%) sepia(38%) saturate(4547%) hue-rotate(172deg) brightness(101%) contrast(101%);
}

.filter-dark-blue {
  filter: invert(18%) sepia(85%) saturate(2810%) hue-rotate(189deg) brightness(93%) contrast(98%);
}

.filter-teal {
  filter: invert(57%) sepia(73%) saturate(4947%) hue-rotate(154deg) brightness(94%) contrast(99%);
}

.filter-light-yellow {
  filter: invert(99%) sepia(37%) saturate(4613%) hue-rotate(298deg) brightness(129%) contrast(98%);
}

.filter-yellow {
  filter: invert(61%) sepia(74%) saturate(484%) hue-rotate(3deg) brightness(106%) contrast(88%);
}

.filter-green {
  filter: invert(48%) sepia(30%) saturate(4387%) hue-rotate(56deg) brightness(101%) contrast(101%);
}

.filter-orange {
  filter: invert(44%) sepia(96%) saturate(2493%) hue-rotate(12deg) brightness(97%) contrast(102%);
}

.filter-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

.stroke-dark-blue {
  stroke: #025a95;
}

.bidRateSheetContainer {
  background: #fff !important;
  display: flex;
  flex-direction: column;
  padding: 0px;
  background: #fff !important;
  min-height: 100vh;
  position: relative;
}
.bidRateSheetContainer span {
  cursor: pointer;
  margin-left: 5px;
}
.bidRateSheetContainer .bidRateSheetInnerContainer {
  background-color: #f5f7f9;
  padding: 0px 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  font-family: Arial;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.25;
  letter-spacing: normal;
  text-align: left;
}
.bidRateSheetContainer .bidRateSheetInnerContainer .upperRightIcons {
  float: right;
  display: flex;
}
.bidRateSheetContainer .bidRateSheetInnerContainer .upperRightIcons .shortIcons {
  margin-top: 7px;
}
.bidRateSheetContainer .bidRateSheetInnerContainer .upperRightIcons .shortIcons .svgStyleOne svg {
  width: 36px;
  height: 36px;
  margin: 12px 0 16px 8px;
  padding: 9px 8.7px 9px 8px;
  border-radius: 4px;
  background-color: #025a95;
}
.bidRateSheetContainer .bidRateSheetInnerContainer .upperRightIcons .shortIcons .svgStyleTwo svg {
  width: 36px;
  height: 36px;
  margin: 12px 0 16px 8px;
  padding: 0px;
  border-radius: 4px;
  background-color: #025a95;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer {
  position: absolute;
  width: 100%;
  top: 10%;
  padding: 10px;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .add {
  height: 200px;
  position: relative;
  display: flex;
  justify-content: center;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .add div {
  position: absolute;
  left: 40%;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .add .aepHeader {
  top: 30%;
  font-size: 24px;
  font-weight: bold;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .add .aepBreadcrumb {
  top: 50%;
  font-size: 18px;
  color: #4a4a4a;
  padding: 0px 40px;
  margin: 10px;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .laborRates {
  overflow-x: scroll;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .tableContainer {
  display: flex;
  flex-direction: column;
  padding: 4px 24px 0 24px;
  background: #fff !important;
  border: 12px solid #e4f4fd;
  min-height: 300px;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .tableContainer span {
  cursor: pointer;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .tableContainer span svg {
  width: 36px;
  height: 36px;
  margin: 12px 0 16px 8px;
  padding: 0px;
  border-radius: 4px;
  background-color: #025a95;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .tableContainer .preferencebtn svg {
  width: 36px;
  height: 36px;
  margin: 12px 0 16px 8px;
  padding: 9px;
  border-radius: 4px;
  background-color: #025a95;
  line-height: 0px !important;
}
.bidRateSheetContainer .bidRateSheetInnerLaborContainer .tableContainer .table thead th {
  padding-left: 9px;
  padding-right: 0px;
}

.bidRateSheetNewTab .row div {
  padding: 5px;
}
.bidRateSheetNewTab .modal-content {
  min-height: 60vh;
}

.laborRatesPreferences {
  background-color: #f5f7f9;
  padding: 0px 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  font-family: Arial;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.25;
  letter-spacing: normal;
  text-align: left;
  empty-cells: show;
  position: relative;
}
.laborRatesPreferences tbody {
  height: 200px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-spacing: 20px 0;
}

.laborRatesScroll {
  overflow-x: auto;
  margin-bottom: 10px;
}
.laborRatesScroll .laborRatesPreview .form-control {
  width: 200px !important;
  height: 1px !important;
}
.laborRatesScroll .laborRatesPreview .icons {
  background: url("https://assets.streamlinehq.com/image/private/w_32,h_32,ar_1/f_auto/v1/icons/streamline-micro-line/interface-essential/user/interface-user-check-minmmo6f21x4blrhdl3z.png?_a=AJFJtWI0");
  padding-right: 10px;
  background-repeat: no-repeat;
  background-position: right;
}
.laborRatesScroll .laborRatesPreview .form-check-input {
  position: relative !important;
  width: 25px;
  height: 25px;
  margin-left: 0px !important;
}
.laborRatesScroll .laborRatesPreview .laborColumnHeader {
  display: flex;
  flex-direction: row;
}
.laborRatesScroll .laborRatesPreview .laborColumnHeader svg {
  margin: 10px;
  width: 25px !important;
  height: 25px !important;
  margin: 5px !important;
  padding: 0px !important;
  border-radius: 0px !important;
  background-color: transparent !important;
}

.disable-icon {
  opacity: 0.7;
  pointer-events: none;
}

.row-bg-color {
  background-color: #e4f4fd !important;
}

.preferenceModalContainer {
  position: absolute;
  z-index: 1000;
  top: 0;
  right: -18px;
  width: 261px;
  height: 480px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 0px;
  background: #fff !important;
}
.preferenceModalContainer .preferenceModalHeader {
  margin: 0px 5px;
  padding: 0px 10px;
  font-size: 16px;
  font-weight: bold;
}
.preferenceModalContainer .preferenceModalSelectAll {
  margin: 0px 5px 0px 5px;
  padding: 0px 10px;
  font-size: 16px;
  font-weight: bold;
}
.preferenceModalContainer .preferenceModalSelect {
  margin: 0px 5px 20px 5px;
  padding: 0px 10px;
  font-size: 16px;
  max-height: 250px;
  overflow-y: auto;
}
.preferenceModalContainer .preferenceModalSelect .preferenceSelection {
  display: flex;
  flex-direction: row;
}
.preferenceModalContainer .form-check-input {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  position: relative;
  bottom: 1px;
  display: initial !important;
  margin-top: 0px !important;
  margin-left: 0px !important;
  margin-right: 6px;
}
.preferenceModalContainer ul {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  padding-left: 0px;
}
.preferenceModalContainer li {
  display: inline-block;
}
.preferenceModalContainer label {
  display: block;
}
.preferenceModalContainer .btnArea {
  padding: 12px 15px 12px 12px;
}

.addNewCodeTable {
  background-color: #f5f7f9 !important;
  margin: 0px !important;
}
.addNewCodeTable .table-responsive {
  height: 400px;
  overflow-y: scroll;
  background-color: #fff !important;
}
.addNewCodeTable .addNewCodeSelection {
  background-color: #e4f4fd !important;
}
.addNewCodeTable .codeTable {
  margin-top: 20px;
}

.preferenceModalSelect::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.preferenceModalSelect::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
}

.preferenceModalSelect::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #9e9fa1;
}

.bidrate-save-error-message {
  float: right;
  width: -moz-fit-content;
  width: fit-content;
  padding: 10px 60px 0 0;
}
.bidrate-save-error-message p {
  color: #da291c;
  font-size: 15px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/lib/styles/scss/variables/_vars-colors.scss","webpack://./src/pages/BidRateSheets/BidRateSheetEntry/BidRateSheetEntry.scss"],"names":[],"mappings":"AAAC,+DAAA;AAqHD;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,sBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADsHA;EACE,yBAAA;ACnHF;;ADuHA;EACE,8FA1HkB;ACMpB;;ADuHA;EACE,6FA5HiB;ACQnB;;ADuHA;EACE,4FA9HiB;ACUnB;;ADuHA;EACE,0FAhIgB;ACYlB;;ADuHA;EACE,+FAjIW;ACab;;ADuHA;EACE,gGAnIgB;ACelB;;ADuHA;EACE,6FAtGa;ACdf;;ADuHA;EACE,+FArIoB;ACiBtB;;ADuHA;EACE,+FAvImB;ACmBrB;;ADuHA;EACE,+FAzIkB;ACqBpB;;ADsHA;EACE,gGAtIiB;ACmBnB;;ADqHA;EACE,iGA7IY;AC2Bd;;ADqHA;EACE,+FA/IiB;AC6BnB;;ADqHA;EACE,+FA9IY;AC4Bd;;ADqHA;EACE,gGA/IoB;AC6BtB;;ADqHA;EACE,6FAjJc;AC+BhB;;ADqHA;EACE,gGAlJa;ACgCf;;ADqHA;EACE,+FAnJc;ACiChB;;ADoHA;EACE,6FAnJa;ACkCf;;ADoHA;EACE,eAzOU;ACwHZ;;AArJA;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;AAwJF;AAvJE;EACE,eAAA;EACA,gBAAA;AAyJJ;AAvJE;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAyJJ;AAvJI;EACE,YAAA;EACA,aAAA;AAyJN;AAvJM;EACE,eAAA;AAyJR;AAvJQ;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBDVE;ACmKZ;AAtJQ;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBDnBE;AC2KZ;AAlJE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;AAoJJ;AAlJI;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAoJN;AAnJM;EACE,kBAAA;EACA,SAAA;AAqJR;AAnJM;EACE,QAAA;EACA,eAAA;EACA,iBAAA;AAqJR;AAnJM;EACE,QAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAqJR;AAlJI;EACE,kBAAA;AAoJN;AAlJI;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,0BAAA;EACA,iBAAA;AAoJN;AAlJM;EACE,eAAA;AAoJR;AAjJQ;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBD1EE;AC6NZ;AA/IQ;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBDpFE;ECqFF,2BAAA;AAiJV;AA9IM;EACE,iBAAA;EACA,kBAAA;AAgJR;;AAxII;EACE,YAAA;AA2IN;AAxIE;EACE,gBAAA;AA0IJ;;AAtIA;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAyIF;AAvIE;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAyIJ;;AArIA;EACE,gBAAA;EACA,mBAAA;AAwIF;AAtII;EACE,uBAAA;EACA,sBAAA;AAwIN;AAtII;EACE,wMAAA;EACA,mBAAA;EACA,4BAAA;EACA,0BAAA;AAwIN;AAtII;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAwIN;AApHI;EACE,aAAA;EACA,mBAAA;AAsHN;AArHM;EACE,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,wCAAA;AAuHR;;AAlHA;EACE,YAAA;EACA,oBAAA;AAqHF;;AAnHA;EACE,oCAAA;AAsHF;;AAlHA;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,2BAAA;AAqHF;AAnHE;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAqHJ;AAnHE;EACE,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAqHJ;AAnHE;EACE,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAqHJ;AApHI;EACE,aAAA;EACA,mBAAA;AAsHN;AAlHE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA;AAoHJ;AAlHE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAoHJ;AAlHE;EACE,qBAAA;AAoHJ;AAlHE;EACE,cAAA;AAoHJ;AAlHE;EACE,4BAAA;AAoHJ;;AAhHA;EACE,oCAAA;EACA,sBAAA;AAmHF;AAlHE;EACE,aAAA;EACA,kBAAA;EACA,iCAAA;AAoHJ;AAlHE;EACE,oCAAA;AAoHJ;AAlHE;EACE,gBAAA;AAoHJ;;AAhHA;EACE,oDAAA;EAEA,mBAAA;EAEA,yBAAA;AAiHF;;AA9GA;EACE,UAAA;EAEA,yBAAA;AAgHF;;AA7GA;EACE,mBAAA;EAEA,oDAAA;EAEA,yBAAA;AA8GF;;AA3GA;EACE,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AA8GF;AA7GE;EACE,cD1TE;EC2TF,eAAA;EACA,iBAAA;AA+GJ","sourcesContent":["﻿/* variables used throughout our scss AND bootstrap variables */\n\n//----------------------------------------------\n// COLORS\n//----------------------------------------------\n$gray-100: #f3f3f3;\n$gray-200: #eceff3;\n$gray-300: #dcdcdc;\n$gray-400: #f5f7f9;\n$gray-600: #9e9fa1;\n$gray-900: #4a4a4a;\n\n$darker-gray:#e2e6ea;\n$dark-gray: $gray-900;\n$icon-gray: $gray-600;\n$mid-gray: $gray-300;\n$lighter-gray: $gray-400;\n$fade-gray: $gray-200;\n$light-gray: $gray-100;\n\n$red: #da291c;\n$light-red: #fae1e2;\n$dark-red: #af2218;\n\n$white: #fff;\n$black: #000;\n\n$duckegg-blue: #e4f4fd;\n$powder-blue: #deecfd;\n$light-blue: #35b2e2;\n$blue: #009cde;\n$dark-blue: #025a95;\n$darker-blue: #1f74b9;\n$link-blue: #007bff;\n$link-hover: #0056b3;\n$faint-blue: #d0ecf8;\n\n$teal: #01a3b0;\n\n$light-yellow: #fce8b6;\n$yellow: #f0b323;\n\n$green: #5ba400;\n$dark-green: #367600;\n$light-green: #edf2e6;\n\n$light-orange: #fcebd2;\n$orange: #df6d00;\n\n$svg-colors: (\n  'icon-gray': $icon-gray,\n  'dark-gray': $dark-gray,\n  'red': $red,\n  'dark-red': $dark-red,\n  'blue': $blue,\n  'dark-blue': $dark-blue,\n  'link-blue': $link-blue,\n  'duckegg-blue': $duckegg-blue,\n  'green': $green,\n  'orange': $orange,\n  'teal': $teal,\n  'yellow': $yellow,\n  'white': $white,\n);\n\n//----------------------------------------------\n// FILTER COLORS\n//----------------------------------------------\n$filter-class: '';\n$filter-light-gray: invert(100%) sepia(5%) saturate(88%) hue-rotate(108deg)\n  brightness(109%) contrast(91%);\n$filter-dark-gray: invert(17%) sepia(57%) saturate(0%) hue-rotate(201deg)\n  brightness(105%) contrast(70%);\n$filter-icon-gray: invert(78%) sepia(6%) saturate(48%) hue-rotate(182deg)\n  brightness(82%) contrast(84%);\n$filter-mid-gray: invert(26%) sepia(0%) saturate(0%) hue-rotate(36deg)\n  brightness(99%) contrast(87%);\n\n$filter-red: invert(19%) sepia(48%) saturate(6736%) hue-rotate(356deg)\n  brightness(91%) contrast(86%);\n$filter-dark-red: invert(17%) sepia(80%) saturate(2657%) hue-rotate(347deg)\n  brightness(92%) contrast(108%);\n\n$filter-white: invert(98%) sepia(100%) saturate(0%) hue-rotate(301deg)\n  brightness(102%) contrast(101%);\n\n$filter-duckegg-blue: invert(90%) sepia(7%) saturate(746%) hue-rotate(183deg)\n  brightness(103%) contrast(104%);\n$filter-powder-blue: invert(80%) sepia(14%) saturate(308%) hue-rotate(180deg)\n  brightness(112%) contrast(98%);\n$filter-light-blue: invert(70%) sepia(90%) saturate(1920%) hue-rotate(164deg)\n  brightness(90%) contrast(97%);\n$filter-blue: invert(41%) sepia(38%) saturate(4547%) hue-rotate(172deg)\n  brightness(101%) contrast(101%);\n$filter-dark-blue: invert(18%) sepia(85%) saturate(2810%) hue-rotate(189deg)\n  brightness(93%) contrast(98%);\n$filter-link-blue: invert(25%) sepia(91%) saturate(1698%) hue-rotate(175deg)\n  brightness(99%) contrast(101%);\n\n$filter-teal: invert(57%) sepia(73%) saturate(4947%) hue-rotate(154deg)\n  brightness(94%) contrast(99%);\n\n$filter-light-yellow: invert(99%) sepia(37%) saturate(4613%) hue-rotate(298deg)\n  brightness(129%) contrast(98%);\n$filter-yellow: invert(61%) sepia(74%) saturate(484%) hue-rotate(3deg)\n  brightness(106%) contrast(88%);\n\n$filter-green: invert(48%) sepia(30%) saturate(4387%) hue-rotate(56deg)\n  brightness(101%) contrast(101%);\n\n$filter-orange: invert(44%) sepia(96%) saturate(2493%) hue-rotate(12deg)\n  brightness(97%) contrast(102%);\n\n$filter-white: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)\n  brightness(103%) contrast(103%);\n\n// COLOR CLASSES\n.light-gray {\n  color: $light-gray !important;\n}\n\n.dark-gray {\n  color: $dark-gray !important;\n}\n\n.mid-gray {\n  color: $mid-gray !important;\n}\n\n.icon-gray {\n  color: $icon-gray !important;\n}\n\n.red {\n  color: $red !important;\n}\n\n.dark-red {\n  color: $dark-red !important;\n}\n\n.white {\n  color: $white !important;\n}\n\n.duckegg-blue {\n  color: $duckegg-blue !important;\n}\n\n.powder-blue {\n  color: $powder-blue !important;\n}\n\n.light-blue {\n  color: $light-blue !important;\n}\n\n.link-blue {\n  color: $link-blue !important;\n}\n\n.blue {\n  color: $blue !important;\n}\n\n.dark-blue {\n  color: $dark-blue !important;\n}\n\n.teal {\n  color: $teal !important;\n}\n\n.light-yellow {\n  color: $light-yellow !important;\n}\n\n.yellow {\n  color: $yellow !important;\n}\n\n.orange {\n  color: $orange !important;\n}\n\n.green {\n  color: $green !important;\n}\n\n// FILTER CLASSES\n.filter-light-gray {\n  filter: $filter-light-gray;\n}\n\n.filter-dark-gray {\n  filter: $filter-dark-gray;\n}\n\n.filter-icon-gray {\n  filter: $filter-icon-gray;\n}\n\n.filter-mid-gray {\n  filter: $filter-mid-gray;\n}\n\n.filter-red {\n  filter: $filter-red;\n}\n\n.filter-dark-red {\n  filter: $filter-dark-red;\n}\n\n.filter-white {\n  filter: $filter-white;\n}\n\n.filter-duckegg-blue {\n  filter: $filter-duckegg-blue;\n}\n\n.filter-powder-blue {\n  filter: $filter-powder-blue;\n}\n\n.filter-light-blue {\n  filter: $filter-light-blue;\n}\n.filter-link-blue {\n  filter: $filter-link-blue;\n}\n.filter-blue {\n  filter: $filter-blue;\n}\n\n.filter-dark-blue {\n  filter: $filter-dark-blue;\n}\n\n.filter-teal {\n  filter: $filter-teal;\n}\n\n.filter-light-yellow {\n  filter: $filter-light-yellow;\n}\n\n.filter-yellow {\n  filter: $filter-yellow;\n}\n\n.filter-green {\n  filter: $filter-green;\n}\n\n.filter-orange {\n  filter: $filter-orange;\n}\n.filter-white {\n  filter: $filter-white;\n}\n\n.stroke-dark-blue {\n  stroke: $dark-blue;\n}\n","@import 'lib/styles/scss/variables/_vars-colors.scss';\n\n.bidRateSheetContainer {\n  background: $white !important;\n  display: flex;\n  flex-direction: column;\n  padding: 0px;\n  background: $white !important;\n  min-height: 100vh;\n  position: relative;\n  span {\n    cursor: pointer;\n    margin-left: 5px;\n  }\n  .bidRateSheetInnerContainer {\n    background-color: #f5f7f9;\n    padding: 0px 10px;\n    margin-bottom: 10px;\n    border-radius: 6px;\n    font-family: Arial;\n    font-size: 16px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2.25;\n    letter-spacing: normal;\n    text-align: left;\n   \n    .upperRightIcons {\n      float: right;\n      display: flex;\n\n      .shortIcons {\n        margin-top: 7px;\n\n        .svgStyleOne svg {\n          width: 36px;\n          height: 36px;\n          margin: 12px 0 16px 8px;\n          padding: 9px 8.7px 9px 8px;\n          border-radius: 4px;\n          background-color: $dark-blue;\n        }\n\n        .svgStyleTwo svg {\n          width: 36px;\n          height: 36px;\n          margin: 12px 0 16px 8px;\n          padding: 0px;\n          border-radius: 4px;\n          background-color: $dark-blue;\n        }\n      }      \n    }\n  }\n\n  .bidRateSheetInnerLaborContainer {\n    position: absolute;\n    width: 100%;\n    top: 10%;\n    padding: 10px;\n\n    .add {\n      height: 200px;\n      position: relative;\n      display: flex;\n      justify-content: center;\n      div {\n        position: absolute;\n        left: 40%;\n      }\n      .aepHeader {\n        top: 30%;\n        font-size: 24px;\n        font-weight: bold;\n      }\n      .aepBreadcrumb {\n        top: 50%;\n        font-size: 18px;\n        color: #4a4a4a;\n        padding: 0px 40px;\n        margin: 10px;\n      }\n    }\n    .laborRates {\n      overflow-x: scroll;\n    }\n    .tableContainer {\n      display: flex;\n      flex-direction: column;\n      padding: 4px 24px 0 24px;\n      background: $white !important;\n      border: 12px solid $duckegg-blue;\n      min-height: 300px;\n\n      span {\n        cursor: pointer;\n        // margin-left: auto;\n\n        svg {\n          width: 36px;\n          height: 36px;\n          margin: 12px 0 16px 8px;\n          padding: 0px;\n          border-radius: 4px;\n          background-color: $dark-blue;\n        }\n      }\n      .preferencebtn {\n        svg {\n          width: 36px;\n          height: 36px;\n          margin: 12px 0 16px 8px;\n          padding: 9px;\n          border-radius: 4px;\n          background-color: $dark-blue;\n          line-height: 0px !important;\n        }\n      }\n      .table thead th {\n        padding-left: 9px;\n        padding-right: 0px;\n      }\n    }\n  }\n}\n\n.bidRateSheetNewTab {\n  .row {\n    div {\n      padding: 5px;\n    }\n  }\n  .modal-content {\n    min-height: 60vh;\n  }\n}\n\n.laborRatesPreferences {\n  background-color: #f5f7f9;\n  padding: 0px 10px;\n  margin-bottom: 10px;\n  border-radius: 6px;\n  font-family: Arial;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2.25;\n  letter-spacing: normal;\n  text-align: left;\n  empty-cells: show;\n  position: relative;\n\n  tbody {\n    height: 200px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-spacing: 20px 0;\n  }\n}\n\n.laborRatesScroll {\n  overflow-x: auto;\n  margin-bottom: 10px;\n  .laborRatesPreview {\n    .form-control {\n      width: 200px !important;\n      height: 1px !important;\n    }\n    .icons {\n      background: url('https://assets.streamlinehq.com/image/private/w_32,h_32,ar_1/f_auto/v1/icons/streamline-micro-line/interface-essential/user/interface-user-check-minmmo6f21x4blrhdl3z.png?_a=AJFJtWI0');\n      padding-right: 10px;\n      background-repeat: no-repeat;\n      background-position: right;\n    }\n    .form-check-input {\n      position: relative !important;\n      width: 25px;\n      height: 25px;\n      margin-left: 0px !important;\n    }\n\n    // input {\n    //   font-size: 16px;\n    //   background-color: transparent;\n    //   border: none;\n    //   width: 91%;\n    //   padding: 12px 12px;\n    //   font-family: 'Poppins', sans-serif;\n    // }\n\n    // input:hover {\n    //   background-color: #fffaf3;\n    // }\n\n    // input:focus {\n    //   outline: 1px solid #ccc;\n    //   border: 1px solid #ccc;\n    // }\n    .laborColumnHeader {\n      display: flex;\n      flex-direction: row;\n      svg {\n        margin: 10px;\n        width: 25px !important;\n        height: 25px !important;\n        margin: 5px !important;\n        padding: 0px !important;\n        border-radius: 0px !important;\n        background-color: transparent !important;\n      }\n    }\n  }\n}\n.disable-icon {\n  opacity: 0.7;\n  pointer-events: none;\n}\n.row-bg-color {\n  background-color: #e4f4fd !important;\n  // border: 0.5px solid #025a95;\n}\n\n.preferenceModalContainer {\n  position: absolute;\n  z-index: 1000;\n  top: 0;\n  right: -18px;\n  width: 261px;\n  height: 480px;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  padding: 0px;\n  background: $white !important;\n\n  .preferenceModalHeader {\n    margin: 0px 5px;\n    padding: 0px 10px;\n    font-size: 16px;\n    font-weight: bold;\n  }\n  .preferenceModalSelectAll {\n    margin: 0px 5px 0px 5px;\n    padding: 0px 10px;\n    font-size: 16px;\n    font-weight: bold;\n  }\n  .preferenceModalSelect {\n    margin: 0px 5px 20px 5px;\n    padding: 0px 10px;\n    font-size: 16px;\n    max-height: 250px;\n    overflow-y: auto;\n    .preferenceSelection {\n      display: flex;\n      flex-direction: row;\n    }\n  }\n\n  .form-check-input {\n    width: 25px;\n    height: 25px;\n    vertical-align: middle;\n    position: relative;\n    bottom: 1px;\n    display: initial !important;\n    margin-top: 0px !important;\n    margin-left: 0px !important;\n    margin-right: 6px;\n  }\n  ul {\n    list-style-type: none;\n    display: flex;\n    flex-direction: column;\n    padding-left: 0px;\n  }\n  li {\n    display: inline-block;\n  }\n  label {\n    display: block;\n  }\n  .btnArea {\n    padding: 12px 15px 12px 12px;\n  }\n}\n\n.addNewCodeTable {\n  background-color: $gray-400 !important;\n  margin: 0px !important;\n  .table-responsive {\n    height: 400px;\n    overflow-y: scroll;\n    background-color: $white !important;\n  }\n  .addNewCodeSelection {\n    background-color: $duckegg-blue !important;\n  }\n  .codeTable {\n    margin-top: 20px;\n  }\n}\n\n.preferenceModalSelect::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n\n  border-radius: 10px;\n\n  background-color: #f5f5f5;\n}\n\n.preferenceModalSelect::-webkit-scrollbar {\n  width: 7px;\n\n  background-color: #f5f5f5;\n}\n\n.preferenceModalSelect::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n\n  background-color: #9e9fa1;\n}\n\n.bidrate-save-error-message {\n  float: right;\n  width: fit-content;\n  padding: 10px 60px 0 0;\n  p {\n    color: $red;\n    font-size: 15px;\n    margin-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
